/**
 * Transform a string to title case
 *
 * @param  {String}
 * @return {String}
 */
export const toTitleCase = str => str.replace(/\w\S*/g, txt => `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`);

export default toTitleCase;
